import React, { useState, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { FaBars } from 'react-icons/fa'; // Pastikan di-import
import ManagerSidebar from '../sidebar/ManagerSidebar';
import { AppContext } from '../../context/AppContext';

const ManagerLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { logout } = useContext(AppContext);

    // Cek ukuran layar untuk responsif
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992);

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth > 992;
            setIsDesktop(desktop);
            if (!desktop) setIsSidebarOpen(false);
            else setIsSidebarOpen(true);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="d-flex min-vh-100" style={{ backgroundColor: '#f4f7fe' }}>

            {/* SIDEBAR */}
            <ManagerSidebar
                isOpen={isSidebarOpen}
                toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
                logout={logout}
                isDesktop={isDesktop}
            />

            {/* MAIN CONTENT AREA */}
            <main
                className="flex-grow-1 position-relative d-flex flex-column"
                style={{
                    marginLeft: (isDesktop && isSidebarOpen) ? '260px' : '0',
                    width: (isDesktop && isSidebarOpen) ? 'calc(100% - 260px)' : '100%',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
            >
                {/* HEADER / TOGGLE BUTTON */}
                <div className="p-3 px-4 d-flex align-items-center gap-3 sticky-top" style={{ zIndex: 990, backgroundColor: 'rgba(244, 247, 254, 0.9)', backdropFilter: 'blur(10px)' }}>
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="btn shadow-sm rounded-3 d-flex align-items-center justify-content-center transition-all hover-scale"
                        style={{border: '1px solid #dee2e6' }}
                    >
                        <FaBars size={20} color="#0d6efd" /> 
                    </button>
                    
                    {/* PERBAIKAN: Tulisan dikembalikan */}
                    <span className="fw-bold text-primary fs-5">Manager Panel</span>
                </div>

                {/* AREA KONTEN */}
                <div className="p-4 pt-2 flex-grow-1 position-relative overflow-hidden">
                    {/* Background decoration */}
                    <div style={styles.blobDecoration}></div>

                    <div className="position-relative z-1 animate-fade-in">
                        <Outlet />
                    </div>
                </div>

                {/* Footer */}
                <footer className="mt-auto py-3 px-4 text-muted small text-center text-md-start" style={{ borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                    &copy; {new Date().getFullYear()} RegisterTKD Event System. All rights reserved.
                </footer>
            </main>

            <style>{`
                .animate-fade-in { animation: fadeIn 0.4s ease-out forwards; }
                .hover-scale { transition: transform 0.2s; }
                .hover-scale:hover { transform: scale(1.05); }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

const styles = {
    blobDecoration: {
        position: 'fixed',
        top: '-10%',
        right: '-5%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(13, 110, 253, 0.05) 0%, rgba(244, 247, 254, 0) 70%)',
        borderRadius: '50%',
        zIndex: 0,
        pointerEvents: 'none'
    }
};

export default ManagerLayout;